import Input from "./Input";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import Checkbox from "./Checkbox";
import Button from "./Button";
import ActionButton from "./ActionButton";
import DatePicker from "./DatePicker";

const Controls = {
    Input,
    RadioGroup,
    Select,
    Checkbox,
    Button,
    ActionButton,
    DatePicker
}

export default Controls;